import {CircularProgress, SelectChangeEvent} from "@mui/material"
import Box from "@mui/material/Box"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import * as React from "react"
import {useEffect} from "react"
import {useNavigate} from "react-router-dom"
import {menuRoutes} from "../../../route"
import {useAppDispatch, useTypedSelector} from "../../../store"
import {
    setAddressComponent,
    setAddressId,
} from "../../../store/header/header.slice"
import {useGetAddressesQuery} from "../../../store/rtk-api/header/header"
import IsError from "../../common/IsError"
import CustomAddressSelect from "./CustomAddressSelect"

export default function NavigationBar() {
    const [value, setValue] = React.useState(0)
    const navigate = useNavigate()
    const {data: addresses, isLoading, isError} = useGetAddressesQuery("")
    const dispatch = useAppDispatch()
    const {addressId, addressComponent} = useTypedSelector(
        (state) => state.header
    )

    useEffect(() => {
        if (addresses) {
            if (!addressId) {
                dispatch(setAddressId(addresses?.results[0]?.id))
            }
        }
    }, [addresses, addressId])
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }
    const handleChangeAddress = (event: SelectChangeEvent) => {
        dispatch(setAddressId(event.target.value))
    }

    const handleNavigate = (routePath: string, routeName: string) => {
        navigate(routePath)
        dispatch(setAddressComponent(routeName))
    }

    return (
        <Box
            sx={{
                width: "100%",
                paddingTop: "10px",
                backgroundColor: "primary.dark",
            }}
        >
            <Box sx={{borderBottom: 1, borderColor: "divider"}}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {menuRoutes.map((route, ind) => {
                        return (
                            <Tab
                                key={route.name}
                                label={route.name}
                                onClick={() => handleNavigate(route.path, route.name)}
                                sx={{color: "secondary.light"}}
                            />
                        )
                    })}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            ml: "10px",
                        }}
                    >
                        {(addressComponent === "Календарь" || addressComponent === "Сверка" || addressComponent === "Врачи") && (
                            <CustomAddressSelect
                                items={addresses?.results}
                                handleChange={handleChangeAddress}
                                name={"address"}
                                value={addressId || 1}
                                width={"400px"}
                            />
                        )}
                        {isLoading && <CircularProgress/>}
                        {<IsError isError={isError}/>}
                    </Box>
                </Tabs>
            </Box>
        </Box>
    )
}
